<template>
    <div class="row botrow">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 infoText">
            <slot name="left"></slot>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 infoText">
            <slot name="center"></slot>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <slot name="right"></slot>
        </div>
    </div>
</template>
<script>
    export default {
        name: "CartFooter"
    }
</script>